<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="handling-filter">
    <ul>
        <li>
            <a href="javascript:void(0)" [attr.class]="totalLocoCountClass" (click)="setSelectedFilter('totalLoco')">
                <h2>{{totalLocoCount ? totalLocoCount : '-'}}</h2>
                <p>{{inboundFilterLabel.totalLoco}}</p>
            </a>
        </li>
        <li>
            <a href="javascript:void(0)" [attr.class]="serviceCenterCountClass" (click)="setSelectedFilter('S')">
                <h2>{{serviceCtrShopRecordCount ? serviceCtrShopRecordCount : '-'}}</h2>
                <p>{{inboundFilterLabel.serviceCenterShop}}</p>
            </a>
        </li>
        <li>
            <a href="javascript:void(0)" [attr.class]="mainTrackCountClass" (click)="setSelectedFilter('M')">
                <h2>{{mainTrackRecordCount ? mainTrackRecordCount : '-'}}</h2>
                <p>{{inboundFilterLabel.mainTrack}}</p>
            </a>
        </li>
        <li>
            <a href="javascript:void(0)" [attr.class]="truckFuelCountClass" (click)="setSelectedFilter('T')">
                <h2>{{truckFuelRecordCount ? truckFuelRecordCount : '-'}}</h2>
                <p>{{inboundFilterLabel.truckFuel}}</p>
            </a>
        </li>
        <li>
            <a href="javascript:void(0)" [attr.class]="toStorageCountClass" (click)="setSelectedFilter('X')">
                <h2>{{toStorageRecordCount ? toStorageRecordCount : '-'}}</h2>
                <p>{{inboundFilterLabel.toStorage}}</p>
            </a>
        </li>
        <li>
            <a href="javascript:void(0)" [attr.class]="nextAssignmentCountClass" (click)="setSelectedFilter('nextAssignment')">
                <h2>{{nextAssignmentRecordCount ? nextAssignmentRecordCount : '-'}}</h2>
                <p>{{inboundFilterLabel.nextAssignment}}</p>
            </a>
        </li>
    </ul>

</div>
<div class="clear"></div>
<h1>{{inboundTable.mainHeader}}</h1>
<div class="table-header handling-tables">
    <div class="column-1">{{inboundTable.headerLabel.trainLoco}}</div>
    <div class="column-2">{{inboundTable.headerLabel.terminalHandlingPlan}}</div>
    <div class="column-3 changed-by-col">{{inboundTable.headerLabel.changedBy}}</div>
    <div class="column-4">{{inboundTable.headerLabel.plannedAssignment}}</div>
    <div class="column-5 projected-departure-col">{{inboundTable.headerLabel.projectedDeparture}}</div>
    <div class="column-6">{{inboundTable.headerLabel.previousPlan}}</div>
</div>
<div class="clear"></div>
<div *ngIf="inboundTrainsArr.length <= 0" class="no-record-found">No record found</div>
<div class="terminal-handling-inbound" id="terminal-handling-inbound">

    <!-- <p-virtualScroller [value]="inboundTrainsArr" scrollHeight="{{scrollDivHeight}}" [itemSize]="100" [lazy]="true" (onLazyLoad)="loadInboundTrainsLazy($event)">
        <ng-template let-inboundTrain let-i="index" pTemplate="item"> -->
    <div class ="scroll-container">
        <div *ngFor="let inboundTrain of inboundTrainsArr; let i = index" [ngClass]="{'alt-row-bg': i % 2 === 0}">
            <div *ngIf="inboundTrain">
                <div class="train-id-date">
                    <p>
                        <a id='{{"inbound" + i + inboundTrain.trainId}}' href="javascript:void(0)" (click)='showTrainTabData("Data", "Train", inboundTrain.trainId);' (contextmenu)='$event.preventDefault(); showContextMenuLinks($event, "Train", "inbound" + i + inboundTrain.trainId, inboundTrain.trainId);'>
                            <strong>{{inboundTrain.trainId ? inboundTrain.trainId : '-'}}</strong>
                        </a>
                    </p>
                    <p class="date"><strong>{{inboundTrain.inboundTrainETA ? inboundTrain.inboundTrainETA : '-'}}</strong></p>
                </div>
                <div class="table-body handling-tables" *ngFor="let terminalHandlingInbound of inboundTrain.locomotiveArr; let i = index;">
                    <div class="column-1" id="loco{{terminalHandlingInbound.locomotiveId}}{{i}}">
                        <a class="loco-id-indent" href="javascript:void(0)" (contextmenu)='$event.preventDefault(); showLocomotiveContextMenu(terminalHandlingInbound.locomotiveId, terminalHandlingInbound.actualLocomotiveId, i);' (click)='showLocomotiveTabData("Data", "Locomotive", terminalHandlingInbound.locomotiveId);'>
                            <strong>{{terminalHandlingInbound.locomotiveId ? terminalHandlingInbound.locomotiveId : '-'}}</strong>
                        </a>
                    </div>
                    <div class="column-2" *ngIf="terminalHandlingInbound.terminalHandlingPlan || terminalHandlingInbound.changedBy">
                        {{terminalHandlingInbound.terminalHandlingPlan ? terminalHandlingInbound.terminalHandlingPlan : '-'}}
                        <p class="hidden-1920" *ngIf="terminalHandlingInbound.changedBy">
                            By:
                            <a href="javascript:void(0)" title="{{terminalHandlingInbound.userName? terminalHandlingInbound.userName : ''}}">
                            {{terminalHandlingInbound.changedBy ? terminalHandlingInbound.changedBy : '-'}}
                        </a>
                        </p>
                    </div>
                    <div class="column-2" *ngIf="!terminalHandlingInbound.terminalHandlingPlan && !terminalHandlingInbound.changedBy">
                        -
                    </div>

                    <div class="column-3 changed-by-col">
                        <a href="javascript:void(0)" title="{{terminalHandlingInbound.userName ? terminalHandlingInbound.userName : ''}}">
                    {{terminalHandlingInbound.changedBy ? terminalHandlingInbound.changedBy : '-'}}
                    </a>
                    </div>
                    <div class="column-4" *ngIf="terminalHandlingInbound.plannedAssignment || terminalHandlingInbound.projectedDeparture">
                        <p>
                            <a id='{{"inbound" + i + inboundTrain.trainId + terminalHandlingInbound.plannedAssignment}}' href="javascript:void(0)" (click)='redirectToTrainOrTerminal(terminalHandlingInbound.plannedAssignment);' (contextmenu)='$event.preventDefault(); showContextMenuLinks($event, "Mix", "inbound" + i + inboundTrain.trainId + terminalHandlingInbound.plannedAssignment, terminalHandlingInbound.plannedAssignment);'>
                                <strong>{{terminalHandlingInbound.plannedAssignment ? terminalHandlingInbound.plannedAssignment : '-'}}</strong>
                            </a>
                            <strong><span *ngIf="terminalHandlingInbound?.intendedUsageCode" class="{{terminalHandlingInbound?.intendedUsageCode === 'Not Power' ? 'color-red':''}}">({{terminalHandlingInbound?.intendedUsageCode}})</span></strong>
                        </p>

                        <p class="hidden-1920" *ngIf="isEtdDisplay(terminalHandlingInbound.plannedAssignment) && terminalHandlingInbound.projectedDeparture">ETD: {{terminalHandlingInbound.projectedDeparture ? terminalHandlingInbound.projectedDeparture : '-'}}
                        </p>

                        <!--<p>(Head-end)</p>-->
                    </div>
                    <div class="column-4" *ngIf="!terminalHandlingInbound.plannedAssignment && !terminalHandlingInbound.projectedDeparture">
                        -
                    </div>

                    <div class="column-5 projected-departure-col">
                        {{terminalHandlingInbound.projectedDeparture ? terminalHandlingInbound.projectedDeparture : '-'}}</div>
                    <div class="column-6">{{terminalHandlingInbound.previousPlan ? terminalHandlingInbound.previousPlan : '-'}}</div>
                </div>
            </div>
        </div>
    </div>
        <!-- </ng-template>
    </p-virtualScroller> -->

    <!-- <p-dataScroller [value]="inboundTrainsArr" [rows]="rowsPerPage" [inline]="true" scrollHeight="{{scrollDivHeight}}" [lazy]="true" (onLazyLoad)="loadInboundTrainsLazy($event)">

        <ng-template let-inboundTrain let-i="index" pTemplate="item">
            <div *ngIf="inboundTrain">
                <div class="train-id-date">
                    <p>
                        <a id='{{"inbound" + i + inboundTrain.trainId}}' href="javascript:void(0)" (click)='showTrainTabData("Data", "Train", inboundTrain.trainId);' (contextmenu)='$event.preventDefault(); showContextMenuLinks($event, "Train", "inbound" + i + inboundTrain.trainId, inboundTrain.trainId);'>
                            <strong>{{inboundTrain.trainId ? inboundTrain.trainId : '-'}}</strong>
                        </a>
                    </p>
                    <p class="date"><strong>{{inboundTrain.inboundTrainETA ? inboundTrain.inboundTrainETA : '-'}}</strong></p>
                </div>
                <div class="table-body handling-tables" *ngFor="let terminalHandlingInbound of inboundTrain.locomotiveArr; let i = index;">
                    <div class="column-1" id="loco{{terminalHandlingInbound.locomotiveId}}{{i}}">
                        <a class="loco-id-indent" href="javascript:void(0)" (contextmenu)='$event.preventDefault(); showLocomotiveContextMenu(terminalHandlingInbound.locomotiveId, terminalHandlingInbound.actualLocomotiveId, i);' (click)='showLocomotiveTabData("Data", "Locomotive", terminalHandlingInbound.locomotiveId);'>
                            <strong>{{terminalHandlingInbound.locomotiveId ? terminalHandlingInbound.locomotiveId : '-'}}</strong>
                        </a>
                    </div>
                    <div class="column-2" *ngIf="terminalHandlingInbound.terminalHandlingPlan || terminalHandlingInbound.changedBy">
                        {{terminalHandlingInbound.terminalHandlingPlan ? terminalHandlingInbound.terminalHandlingPlan : '-'}}
                        <p class="hidden-1920" *ngIf="terminalHandlingInbound.changedBy">
                            By:
                            <a href="javascript:void(0)" title="{{terminalHandlingInbound.userName? terminalHandlingInbound.userName : ''}}">
                            {{terminalHandlingInbound.changedBy ? terminalHandlingInbound.changedBy : '-'}}
                        </a>
                        </p>
                    </div>
                    <div class="column-2" *ngIf="!terminalHandlingInbound.terminalHandlingPlan && !terminalHandlingInbound.changedBy">
                        -
                    </div>

                    <div class="column-3 changed-by-col">
                        <a href="javascript:void(0)" title="{{terminalHandlingInbound.userName ? terminalHandlingInbound.userName : ''}}">
                    {{terminalHandlingInbound.changedBy ? terminalHandlingInbound.changedBy : '-'}}
                    </a>
                    </div>
                    <div class="column-4" *ngIf="terminalHandlingInbound.plannedAssignment || terminalHandlingInbound.projectedDeparture">
                        <p>
                            <a id='{{"inbound" + i + inboundTrain.trainId + terminalHandlingInbound.plannedAssignment}}' href="javascript:void(0)" (click)='redirectToTrainOrTerminal(terminalHandlingInbound.plannedAssignment);' (contextmenu)='$event.preventDefault(); showContextMenuLinks($event, "Mix", "inbound" + i + inboundTrain.trainId + terminalHandlingInbound.plannedAssignment, terminalHandlingInbound.plannedAssignment);'>
                                <strong>{{terminalHandlingInbound.plannedAssignment ? terminalHandlingInbound.plannedAssignment : '-'}}</strong>
                            </a>
                            <strong><span *ngIf="terminalHandlingInbound?.intendedUsageCode" class="{{terminalHandlingInbound?.intendedUsageCode === 'Not Power' ? 'color-red':''}}">({{terminalHandlingInbound?.intendedUsageCode}})</span></strong>
                        </p>

                        <p class="hidden-1920" *ngIf="isEtdDisplay(terminalHandlingInbound.plannedAssignment) && terminalHandlingInbound.projectedDeparture">ETD: {{terminalHandlingInbound.projectedDeparture ? terminalHandlingInbound.projectedDeparture : '-'}}
                        </p>

                        <p>(Head-end)</p>-->
                        <!--
                    </div>
                    <div class="column-4" *ngIf="!terminalHandlingInbound.plannedAssignment && !terminalHandlingInbound.projectedDeparture">
                        -
                    </div>

                    <div class="column-5 projected-departure-col">
                        {{terminalHandlingInbound.projectedDeparture ? terminalHandlingInbound.projectedDeparture : '-'}}</div>
                    <div class="column-6">{{terminalHandlingInbound.previousPlan ? terminalHandlingInbound.previousPlan : '-'}}</div>
                </div>
            </div>
        </ng-template>
    </p-dataScroller> -->
</div>